import { FORM_ID } from "../../../../../constants/Forms";
import ReviewSignSectionHeader from "./ReviewSignSectionHeader";

function ReviewBrokerDealer(props) {
  const toggleForm = () => {
    props.toggleForm(FORM_ID.BROKER_DEALER);
  };
  return (
    <div id="brkr-dlr">
      <ReviewSignSectionHeader
        toggleForm={toggleForm}
        id={"brokerDealer"}
        headerText="Broker Dealer Information"
      ></ReviewSignSectionHeader>

      <div className="row">
        <div className="col-lg-3 col-md-6 col-sm-12" id="delr-rgstrd">
          <h5>Are you registered with a Broker Dealer?</h5>
        </div>
        <div id="registered" className="col-lg-3 col-md-6 col-sm-12 data">
          {props.brokerDealerInformation.brokdealbool ? "Yes" : "No"}
        </div>
        {props.brokerDealerInformation.brokdealbool && (
          <>
            <div
              className="col-lg-3 col-md-6 col-sm-12"
              id="anti-money-laundering"
            >
              <h5 id="aml">
                Have you completed Anti-Money Laundering training through your
                Broker Dealer?
              </h5>
            </div>
            <div id="completed" className="col-lg-3 col-md-6 col-sm-12 data">
              {props.brokerDealerInformation.amltraining ? "Yes" : "No"}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12" id="dealer-name">
              <h5>Broker Dealer Name</h5>
            </div>
            <div id="broker_name" className="col-lg-3 col-md-6 col-sm-12 data">
              {props.brokerDealerInformation.brokdealname}
            </div>
            {props.brokerDealerInformation.amltraining ? (
              <>
                <div className="col-lg-3 col-md-6 col-sm-12" id="training">
                  <h5 id="trng-dte">
                    Anti-Money Laundering Training Completion Date
                  </h5>
                </div>
                <div
                  id="training_date"
                  className="col-lg-3 col-md-6 col-sm-12 data"
                >
                  {props.brokerDealerInformation.amltrainingdate}
                </div>
              </>
            ) : (
              <>
                <div className="col-lg-3 col-md-6 col-sm-12"></div>
                <div className="col-lg-3 col-md-6 col-sm-12 data"></div>
              </>
            )}

            <div className="col-lg-3 col-md-6 col-sm-12" id="crd">
              <h5 id="pcrdn">
                Personal Central Registration Depository Number (CRD)
              </h5>
            </div>
            <div id="CRD" className="col-lg-3 col-md-6 col-sm-12 data">
              {props.brokerDealerInformation.crdnumber}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ReviewBrokerDealer;
